import React from 'react';

import { withBemMod } from '@bem-react/core';

import { Palettes } from '../../../PaletteGeneration';
import { cnButton } from '../../Button.cn';
import type { ButtonBaseProps } from '../../Button.types';

import './Button_view_media.css';

export type WithViewMediaProps = {
    view?: 'media';
};

export const withViewMedia = withBemMod<WithViewMediaProps, ButtonBaseProps>(
    cnButton(),
    { view: 'media' },
    (Button) => (props) => (
        <Button {...props} className={cnButton(null, [props.className, Palettes.static])} />
    ),
);
